<template>
    <header-layout></header-layout>
    <div class="price-bg"></div>
    <div class="page-padding header-wrapper banner aos-init aos-animate">
        <div class="header section-wrap row middle-xs center-xs start-md">
            <div class="left col-md-6 text-content aos-init aos-animate">
                <div class="header-text-left">
                    <div class="l-title-h1">
                        <div class="title">下载客户端</div>
                        <div class="desc">查看设计更方便, 演示原型更逼真</div>
                        <div class="descPlus" style="display: none;"></div>
                    </div>
                    <div class="btn-wrapper">
                        <div class="ios-qrcode-wrapper qrcode-wrapper-download">
                            <a-button class="pointer" type="primary" shape="round" size="large">
                                <img class="download-icon" src="@/assets/icon/download.png" />
                                Windows下载
                            </a-button>
                            <a-button class="pointer" style="margin-left: 1rem" type="primary" shape="round" size="large">
                                <img class="download-icon" src="@/assets/icon/download.png" />
                                macOS下载
                            </a-button>
                        </div>
                    </div>
                    <div class="jurisdiction"><span class="spna-center">提供：北京尽微致广信息技术有限公司</span> <span class="span-left"
                            style="margin-left: 10px;"><br />版本：6.0.4</span> <span><span class="hover-span"
                                style="margin-left: 10px;"></span></span> <span><span class="hover-span"
                                style="margin-left: 10px;"></span></span></div>
                </div>
            </div>
            <div class="right col-md-6 col-sm-11 col-xs-12 right aos-init aos-animate">
                <div class="banner-img"><img src="@/assets/image/download_content.png" alt=""></div>
            </div>
        </div> <img src="@/assets/image/HedaerWave.png" alt="" class="wave_bg">
    </div>
    <footer-layout></footer-layout>
</template>

<script>
import FooterLayout from './layout/footerLayout.vue'
import headerLayout from './layout/headerLayout.vue'
export default {
    components: { headerLayout, FooterLayout },

}
</script>

<style scoped>
.price-bg {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    width: 100%;
    height: 100vh;
    background-image: linear-gradient(to bottom, #cbdcf9, #FFFEFF);
    z-index: -1;
}

.header-wrapper .header {
    min-height: 100%;
}

.header {
    border-bottom: 1px solid #F3F3F3;
}

.section-wrap {
    max-width: 1280px;
    margin: 0 auto;
}

.start-md {
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    text-align: start;
}

.middle-xs {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.row {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 0;
    -ms-flex: 0 1 auto;
    flex: 0 1 auto;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}

.l-title-h1 .title {
    font-size: 3.4rem;
    font-weight: 600;
    line-height: 1.5;
    color: rgba(18, 20, 28, 0.9);
}

.l-title-h1 .desc,
.l-title-h1 .descPlus {
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 1.8;
    margin-top: 0.8rem;
    color: rgba(18, 20, 28, 0.5);
}

.banner {
    height: 80vh;
    min-height: 500px;
}

.banner .btn-wrapper {
    display: inline-block;
    margin-top: 4rem;
}

.jurisdiction {
    width: 100%;
    font-family: Source Han Sans CN;
    font-size: 14px;
    font-weight: normal;
    color: rgba(18, 20, 28, 0.5);
    /* position: absolute; */
    margin-top: 10px;
}

.banner .banner-img {
    width: 100%;
}

.wave_bg {
    width: 100%;
    position: absolute;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    left: 50%;
    position: absolute;
    bottom: 0;
    pointer-events: none;
    z-index: -1;
}

.banner-img img {
    width: 100%;
}

.left,
.right {
    flex: 1;
}

.download-icon {
    width: 20px;
    position: relative;
    top: -2px;
    left: -4px;
}

.header-text-left {
    position: relative;
    left: 15%;
}

.banner-img {
    position: relative;
    right: 15%;
}

@media (max-width: 900px) {
    .header-text-left {
        position: relative;
        left: 5%;
    }

    .banner-img {
        position: relative;
        right: 5%;
    }
}

@media (max-width: 765px) {
    .header-wrapper .header {
        height: unset;
    }

    .row {
        flex-direction: column;
    }

    .header-text-left {
        position: relative;
        left: 0%;
    }

    .banner-img {
        position: relative;
        right: 0%;
    }

    .banner {
        height: auto;
        min-height: 500px;
    }

    .left,
    .right {
        margin: 7% 0;
    }
}
</style>